import { render, staticRenderFns } from "./LearnerProfileConceptBlockComponent.vue?vue&type=template&id=5b674abe"
import script from "./LearnerProfileConceptBlockComponent.vue?vue&type=script&lang=js"
export * from "./LearnerProfileConceptBlockComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports